import * as tslib_1 from "tslib";
import { PropostaStateService } from './../../../../shared/states/proposta-state.service';
import { NacionalidadesService } from './../../../../../services/nacionalidade/nacionalidades.service';
import { FichaService } from './../../../../../ficha-veiculo/ficha-veiculo.service';
import { OnInit, OnDestroy, EventEmitter } from '@angular/core';
import * as moment from 'moment';
export class DadosComplementaresComponent {
    constructor(state, fichaService, nacionalidadesService) {
        this.state = state;
        this.fichaService = fichaService;
        this.nacionalidadesService = nacionalidadesService;
        this.avalistaNumero = -1;
        this.next = new EventEmitter();
        this.previous = new EventEmitter();
        this.isNomePaiClienteTexto = false;
        this.listaNaturalCidadeCliente = [];
        this.isLoadingNaturalCidadeCliente = false;
        this.listaNacionalidadeCliente = [];
        this.isLoadingNacionalidadeCliente = false;
    }
    ngOnInit() {
        this.proposta = this.state.getLast();
        this.cliente = Object.assign({}, this.clienteEntity);
        if (!this.cliente.nacionalidade) {
            this.cliente.nacionalidade = { id: 1 };
        }
        console.log('Iniciando Dados Complementares Component');
        if (this.cliente.tipoDocumentoDataEmissao) {
            this.cliente.tipoDocumentoDataEmissao = moment.unix(this.cliente.tipoDocumentoDataEmissao / 1000).format('DDMMYYYY');
        }
        this.loadNacionalidadeCliente();
    }
    ngOnDestroy() {
        console.log('Destruindo Dados Complementares Component');
    }
    salvar() {
        const tipoDocumentoDataEmissao = moment(this.cliente.tipoDocumentoDataEmissao, 'DDMMYYYY').unix() * 1000;
        this.clienteEntity = Object.assign({}, this.cliente, { tipoDocumentoDataEmissao });
        this.state.setState(this.proposta);
    }
    onClickNomePaiCliente() {
        this.isNomePaiClienteTexto = !this.isNomePaiClienteTexto;
        if (this.isNomePaiClienteTexto) {
            this.cliente.nomePai = 'NAO DECLARADO';
        }
        else {
            this.cliente.nomePai = '';
        }
    }
    loadNacionalidadeCliente() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.listaNacionalidadeCliente = [];
            this.isLoadingNacionalidadeCliente = true;
            try {
                this.listaNacionalidadeCliente = yield this.nacionalidadesService.nacionalidades().toPromise();
                if (this.cliente.naturalDeUf) {
                    yield this.loadNaturalCidadeCliente();
                }
            }
            finally {
                this.isLoadingNacionalidadeCliente = false;
            }
        });
    }
    onChangeNacionalidade(data) {
        if (data !== '1') {
            this.cliente.naturalDeUf = '';
            this.cliente.naturalDe = '';
        }
    }
    loadNaturalCidadeCliente() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.listaNaturalCidadeCliente = [];
            this.isLoadingNaturalCidadeCliente = true;
            try {
                const res = yield this.fichaService
                    .getCidadePorUf(this.cliente.naturalDeUf)
                    .toPromise();
                this.listaNaturalCidadeCliente = res.cidades;
            }
            finally {
                this.isLoadingNaturalCidadeCliente = false;
            }
        });
    }
    onChangeNaturalUfCliente() {
        this.cliente.naturalDe = '';
        this.loadNaturalCidadeCliente();
    }
    onClickNext() {
        this.salvar();
        this.next.emit();
    }
    onClickPrevious() {
        this.salvar();
        this.previous.emit();
    }
    get clienteEntity() {
        if (this.avalistaNumero > 0) {
            return this.proposta.avalistas[`${this.avalistaNumero}`];
        }
        return this.proposta.cliente;
    }
    set clienteEntity(cliente) {
        if (this.avalistaNumero > 0) {
            this.proposta.avalistas[`${this.avalistaNumero}`] = cliente;
        }
        else {
            this.proposta.cliente = cliente;
        }
    }
}
